module.exports = __webpack_public_path__ + "static/img/2.824d14e.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/12/10/2.png
// module id = 8ib+
// module chunks = 1